import  React from "react";

const Error = () => {
  return <div>Erreur 404</div>;
};

export default Error;
